import React, { memo, useState } from 'react';
import { useAction, useAuthenticatedSocket } from '../../Api/newSockets.api';
import Repeatable from 'react-repeatable';

type Props = {
    deviceId: string,
    authSocket: any,
}

const Joystick = memo((props: Props) => {

    const { getAction, connected, runAction } = useAction();

    console.log("rerendered");
    const [vacumOn, setVacumOn] = useState(false);
    const [distance, setDistance] = useState("10");
    const [coordPosition, setCoordPosition] = useState({"x": 0, "y": 0, "z": 0});


    const actions = {
        setPositionRelative: {
            "action": {
                "id": 21,
                "name": "SetPositionRelative",
                "dateCreated": "2020-05-11T21:43:12.000Z",
                "dateModified": "2020-05-11T21:43:12.000Z",
                "inputs": [
                    {
                        "label": "x",
                        "type": 0,
                        "value": "0"
                    },
                    {
                        "label": "y",
                        "type": 0,
                        "value":"0"
                    },
                    {
                        "label": "z",
                        "type": 0,
                        "value":"0"
                    }
                ],
                "outputs": [],
                "actionGroupId": 3,
                "deviceTypeId": 2,
                "nodeTypeId": 4,
                "code": null
            }
        },
        pull: {
            "action": {
                "id": 6,
                "name": "Pull",
                "dateCreated": "2020-05-11T21:43:12.000Z",
                "dateModified": "2020-05-11T21:43:12.000Z",
                "inputs": [],
                "outputs": [],
                "actionGroupId": 3,
                "deviceTypeId": 2,
                "nodeTypeId": 4,
                "code": null
            }
        },
        "drop": {
            "action": {
                "id": 7,
                "name": "Drop",
                "dateCreated": "2020-05-11T21:43:12.000Z",
                "dateModified": "2020-05-11T21:43:12.000Z",
                "inputs": [],
                "outputs": [],
                "actionGroupId": 3,
                "deviceTypeId": 2,
                "nodeTypeId": 4,
                "code": null
            }
        }
    }

    const runSetPosition = (positiveDirection, label) => {
        console.log(label)

        actions.setPositionRelative.action.inputs = [{label: label, value: (positiveDirection ? distance : -distance).toString(), type: 0}];
        console.log("new", actions.setPositionRelative.action.inputs);

        props.authSocket.emit('runAction', {action: actions.setPositionRelative.action, deviceId: props.deviceId});
        
    }

    const runSetPositionAbsolute = (direction) => {
        if (direction) {
            //runAction({ id: 106, inputs: [] }, parseInt(props.deviceId));
            runAction({ id: 52, inputs: [{ label: 'z', type: 0, value: 'device.zmin' }, { label: 'speed', type: 0, value: '5' }] }, parseInt(props.deviceId));
        }
        else {
            runAction({ id: 52, inputs: [{ label: 'z', type: 0, value: 'device.zmax' }, { label: 'speed', type: 0, value: '5' }] }, parseInt(props.deviceId));
        }
    }

    const runRotation = (positiveDirection) => {
        var newDegree = (positiveDirection ? distance : -distance).toString();
        actions.setPositionRelative.action.inputs = [{label: 'angle', value: newDegree, type: 0}];
        console.log(actions.setPositionRelative.action, newDegree);
        props.authSocket.emit('runAction', {action: actions.setPositionRelative.action, deviceId: props.deviceId});

    }

    const runVacum = (vacumOn) => {
        var newStatus = vacumOn;
        setVacumOn(newStatus);
        if(newStatus) {
            props.authSocket.emit('runAction', {action: actions.pull.action, deviceId: props.deviceId});

        }
        else {

            props.authSocket.emit('runAction', {action: actions.drop.action, deviceId: props.deviceId});
        }
    }

    const RepeatableButton = ({ onClick, tag, ...props }) => (
        <Repeatable
            tag={tag}
            type={tag}
            onHold={onClick}
            repeatDelay={0}
            repeatInterval={150}
            {...props}
        />
    );

    const onDistanceChange = (e) => {
        console.log(e.target.value);
        setDistance(e.target.value);
    }

    return (
        <div className="joystick-container">
            <div className="radio-form">
                <p className="form-title">Distance</p>
                <div className="radio-container" >
                    <label>
                        <input type="radio" value="1" onChange={onDistanceChange} checked={distance == "1"} name="distance" /> 
                        1 mm
                    </label>
                    <label>
                        <input type="radio" value="5" onChange={onDistanceChange} checked={distance == "5"} name="distance" /> 
                        5 mm
                    </label>
                    <label>
                        <input type="radio" value="10" onChange={onDistanceChange} checked={distance == "10"} name="distance" /> 
                        10 mm
                    </label>
                    <label>
                        <input type="radio" value="50" onChange={onDistanceChange} checked={distance == "50"} name="distance" /> 
                        50 mm
                    </label>
                    <label>
                        <input type="radio" value="100" onChange={onDistanceChange} checked={distance == "100"} name="distance" /> 
                        100 mm
                    </label>
                </div>
            </div>
            <div className="joystick">
                <svg viewBox="113.191 80.598 724.849 340" xmlns="http://www.w3.org/2000/svg" >
                <RepeatableButton tag="path" onClick={e => runSetPosition(false, "y")} d="M 285.886 384.469 L 285.886 320.269 C 308.068 313.038 325.598 295.508 332.829 273.326 L 397.029 273.326 C 387.461 330.096 342.657 374.901 285.886 384.469 Z" className="circle_controls" transform="matrix(0.707106, 0.707107, -0.707107, 0.707106, 254.276985, -112.682361)"/>
                    <RepeatableButton tag="path" onClick={e => runSetPosition(false, "x")} d="M 240.43 320.269 L 240.43 384.469 C 183.659 374.901 138.855 330.096 129.287 273.326 L 193.487 273.326 C 200.718 295.508 218.248 313.038 240.43 320.269 Z" className="circle_controls" transform="matrix(0.707106, 0.707107, -0.707107, 0.707106, 254.276985, -112.682361)"/>
                    <RepeatableButton tag="path" onClick={e => runSetPosition(true, "y")} d="M 318.729 84.294 L 318.729 148.494 C 296.547 155.725 279.018 173.255 271.787 195.437 L 207.587 195.437 C 217.155 138.667 261.959 93.862 318.729 84.294 Z" className="circle_controls"transform="matrix(0.707106, 0.707107, -0.707107, 0.707106, 175.977217, -145.115209)"/>
                    <RepeatableButton tag="path" onClick={e => runSetPosition(true, "x")} d="M 285.886 180.927 L 285.886 116.727 C 342.657 126.295 387.461 171.1 397.029 227.87 L 332.829 227.87 C 325.598 205.688 308.068 188.158 285.886 180.927 Z" className="circle_controls" transform="matrix(0.707106, 0.707107, -0.707107, 0.707106, 254.276985, -112.682361)"/>
                    <RepeatableButton tag="path" onClick={e => runSetPosition(true, "y")} d="M 263.159 132.362 L 276.914 151.756 L 271.311 151.756 L 271.311 160.345 L 255.007 160.345 L 255.007 151.756 L 249.403 151.756 L 263.159 132.362 Z" className="signs"/>
                    <RepeatableButton tag="path" onClick={e => runSetPosition(false, "y")} d="M 263.364 341.109 L 277.119 360.503 L 271.516 360.503 L 271.516 369.092 L 255.212 369.092 L 255.212 360.503 L 249.608 360.503 L 263.364 341.109 Z" className="signs" transform="matrix(-1, 0, 0, -1, 526.72699, 710.201019)"/>
                    <RepeatableButton tag="path" onClick={e => runSetPosition(false, "x")} d="M 157.158 236.606 L 170.913 256 L 165.31 256 L 165.31 264.589 L 149.006 264.589 L 149.006 256 L 143.402 256 L 157.158 236.606 Z" className="signs" transform="matrix(0, -1, 1, 0, -93.440002, 407.75499)"/>
                    <RepeatableButton tag="path" onClick={e => runSetPosition(true, "x")} d="M 369.307 236.607 L 383.062 256.001 L 377.459 256.001 L 377.459 264.59 L 361.155 264.59 L 361.155 256.001 L 355.551 256.001 L 369.307 236.607 Z" className="signs" transform="matrix(0, 1, -1, 0, 619.904999, -118.708008)"/>
                    <text className="text" x="258.261" y="197.553">Y+</text>
                    <text className="text" x="259.118" y="315.462">Y-</text>
                    <text className="text" x="200.812" y="251.658">X-</text>
                    <text className="text" x="309.697" y="252.084">X+</text>


                    <RepeatableButton tag="path" onClick={e => runSetPositionAbsolute(true)} d="M 539.184 120.287 L 583.091 201.17 L 495.276 201.17 L 539.184 120.287 Z" className="triangle_controls" />
                    <RepeatableButton tag="path" onClick={e => runSetPositionAbsolute(false)} d="M -539.02 -380.537 L -495.113 -299.654 L -582.928 -299.654 L -539.02 -380.537 Z" className="triangle_controls" transform="matrix(-1, 0, 0, -1, 0, 0)" />
                    <text className="text" x="532.526" y="220.61">Z+</text>
                    <text className="text" x="534.702" y="290.678">Z-</text>
                    <RepeatableButton tag="rect" onClick={e => runSetPositionAbsolute(false)} x="217.537" y="254.143" width="5.546" height="24.244" className="signs" transform="matrix(0, 1, -1, 0, 805.140747, 99.919144)" />
                    <RepeatableButton tag="path" onClick={e => runSetPositionAbsolute(true)} d="M 549.409 174.769 L 549.409 179.635 L 541.206 179.635 L 541.206 187.838 L 536.34 187.838 L 536.34 179.635 L 528.137 179.635 L 528.137 174.769 L 536.34 174.769 L 536.34 166.566 L 541.206 166.566 L 541.206 174.769 L 549.409 174.769 Z" className="signs" />


                    <RepeatableButton tag="path" onClick={e => runRotation(true)} d="M 724.372 119.423 L 751.544 169.478 L 697.199 169.478 L 724.372 119.423 Z" className="triangle_controls"/>
                    <RepeatableButton tag="path" onClick={e => runRotation(false)} d="M -724.27 -280.481 L -697.098 -230.426 L -751.443 -230.426 L -724.27 -280.481 Z" className="triangle_controls" transform="matrix(-1, 0, 0, -1, 0, 0)"/>
                    <RepeatableButton tag="text" onClick={e => runRotation(true)} className="text" x="688.733" y="187.508">ROTATION+</RepeatableButton>
                    <text className="text" x="689.406" y="220.645">ROTATION-</text>

                    <rect x="134.625" y="157.278" width="3.432" height="15.004" className="text" transform="matrix(0, 1, -1, 0, 888.960938, 106.819656)"/>
                    <path d="M 730.7 153.139 L 730.7 156.152 L 725.623 156.152 L 725.623 161.228 L 722.612 161.228 L 722.612 156.152 L 717.536 156.152 L 717.536 153.139 L 722.612 153.139 L 722.612 148.063 L 725.623 148.063 L 725.623 153.139 L 730.7 153.139 Z" className="text"/>
                    <rect className={`controls ${vacumOn && "on"}`} onClick={e => runVacum(true)} x="675.657" y="339.226" width="44.626" height="44.626" rx="5" ry="5"/>
                    <rect className={`controls ${!vacumOn && "off"}`} onClick={e => runVacum(false)} x="734.752" y="339.425" width="44.626" height="44.626" rx="5" ry="5"/>
                    <text onClick={e => runVacum(true)}  className="text" x="687.351" y="365.85" >ON</text>
                    <text onClick={e => runVacum(false)}  className="text" x="743.525" y="366.155" >OFF</text>
                    <text className="text" x="679.545" y="329.346">VACUM</text>

                </svg>
                <div className="slider-container">
                    <p className="label">Max speed</p>
                    <input className="speed-control" type="range" min="0" max="10" step="1" />
                    <p className="label">Min speed</p>
                </div>
            </div>

        </div>
    )
});

export default Joystick;